import { useEffect } from 'react';

let modalOpen = false;

export const useModalOpen = () => {
  useEffect(() => {
    modalOpen = true;
    return () => { modalOpen = false; };
  }, []);
};

export const isModalOpen = () => modalOpen;
